<template>
  <div class="freight-details">
    <b-dropdown
      :id="'freight-details-dropdown' + freightTableId"
      text="Freight Details"
      :ref="'freight-details-dropdown' + freightTableId"
      @hidden="catchHtmlTable"
    >
      <Searcher
        :id="'freight-details-table' + freightTableId"
        :fields="freightDetailsFields"
        :data="freightDetailsTableContent"
        addRows
        deleteRows
        :tableStyles="tableStyles"
        ref="freight-details"
      >
        <template #table-header>
          <tr name="table-fields">
            <th :style="tableStyles.header" :colspan="6">
              Freight Details - Trip {{ freightTableId + 1 }}
            </th>
          </tr>
        </template>

        <template #key="slotProps">
          <input
            v-model="slotProps.row.key"
            class="table-canned__tableField"
            type="text"
            cell-type="editable-cell"
          />
        </template>

        <template #value="slotProps">
          <input
            v-model="slotProps.row.value"
            class="table-canned__tableField"
            type="text"
            cell-type="editable-cell"
          />
        </template>
      </Searcher>
      <div class="custom-modal-footer">
        <b-button class="custom-modal-footer__ok-button" @click="hideModal">
          OK
        </b-button>
      </div>
    </b-dropdown>
  </div>
</template>

<script>
import Searcher from "roachcat-components-library/table";
export default {
  name: "FreightDetails",
  components: {
    Searcher
  },
  props: [
    "freightTableId",
    "ftlQuoteTableInformation",
    "cannedResponseName",
    "currentCannedResponse"
  ],
  data() {
    return {
      freightDetailsFields: [],
      freightDetailsTableContent: [],
      tableStyles: {
        table: {
          //Modifica los estilos de la etiqueta “table”
          "border-collapse": "collapse",
          width: "700px",
          "text-align": "center"
        },
        header: {
          //Modifica los estilos de las celdas del header que contiene los campos pasados en la propiedad “fields”.
          "background-color": "rgb(230, 230, 250)",
          border: "1px solid rgb(230, 230, 250)",
          "font-size": "13px",
          padding: "4px 8px"
        },
        th: {
          //Modificar los estilos de cada una de las celdas de la información
          "background-color": "rgb(239, 239, 239)",
          "line-height": "10px",
          border: "1px solid rgb(230, 230, 250)",
          "font-size": "12px"
        }
      },
      actualQueue: null,
      haulInfo: null,
      ftlQuoteTableInfo: null,
      htmlTable: null
    };
  },
  created() {
    if (this.currentCannedResponse) {
      this.freightDetailsTableContent = this.currentCannedResponse?.table_content;
      const arrayRow = Object.keys(this.freightDetailsTableContent[0]);
      for (let i = 0; i < arrayRow.length; i += 1) {
        this.freightDetailsFields.push({
          label: "",
          propName: arrayRow[i]
        });
      }
      this.actualQueue = localStorage.getItem("actual-queue");
      this.haulInfo = this.$store.getters["quotes/quote/showQuoteById"].haul;
      this.ftlQuoteTableInfo = [...this.ftlQuoteTableInformation];
      this.buildTable();
      let isPartialMode = this.validateModeType();
      if (isPartialMode) {
        this.pushPartialModeRow();
      }
    }
  },
  mounted() {
    this.catchHtmlTable();
  },
  methods: {
    validateModeType() {
      if (
        this.haulInfo[this.freightTableId].tms_mode.name
          .toLowerCase()
          .match("partial")
      ) {
        return true;
      } else {
        return false;
      }
    },
    pushPartialModeRow() {
      this.freightDetailsTableContent.push({
        key: this.cannedResponseName.toLowerCase().match("español")
          ? "Pies Lineales"
          : "Linear Feet",
        value: this.haulInfo[this.freightTableId]?.linear_feet
      });
    },
    buildTable() {
      for (let i in this.freightDetailsTableContent) {
        this.freightDetailsTableContent[i].value = this.ftlQuoteTableInfo[
          i
        ]?.value;
      }
    },
    catchHtmlTable() {
      let tableInfo = {};
      tableInfo.tableType = "freight-details";
      tableInfo.tableId = `{freight_details_trip_${this.freightTableId + 1}}`;
      this.htmlTable = this.$refs["freight-details"].getTableHtml();
      tableInfo.htmlTable = this.htmlTable.outerHTML;
      this.$emit("addTableHtml", tableInfo);
      this.$refs[`freight-details-dropdown${this.freightTableId}`].hide(true);
    },
    hideModal() {
      this.$refs["freight-details-dropdown" + this.freightTableId].hide(true);
      this.catchHtmlTable();
    }
  }
};
</script>

<style lang="scss" scoped>
.freight-details {
  @extend %canned-tables;
  display: flex;
}
::v-deep .table-component {
  padding: 0 1rem;
}
::v-deep .button-toolbar {
  margin: 0;
  display: flex;
  justify-content: start;
  &__button {
    @include secondary-button;
  }
}
::v-deep .table td {
  font-size: 13px;
  padding: 0;
  border: 1px solid rgb(230, 230, 250);
}
::v-deep .table__delete-button {
  & button {
    border-radius: 0.25rem;
  }
}
.table-canned {
  &__tableField {
    display: inline-block;
    border: none;
    min-width: 100px;
    width: 100%;
    height: 28px;
    &:focus {
      outline: none;
    }
  }
}
</style>
